export default "__VITE_ASSET__3IBE3fFn__"